import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { toUserSelectItems } from '../../../User'

import {
  REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES,
  REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT,
  REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT,
} from './RequestProfileWidgetResponsibleManagers.constants'

export function getInitialValues(assignees) {
  return {
    [REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]:
      toUserSelectItems(assignees || EMPTY_LIST),
  }
}

export function getPayload(values) {
  const payload = {
    [REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]: {
      user_ids: getItemsIds(
        values[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES],
        'value'
      ),
    },
  }

  if (values[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_IS_COMMENT]) {
    payload[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES] = {
      ...payload[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES],
      [REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT]:
        values[REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_COMMENT] ?? null,
    }
  }

  return payload
}

export function getRemainingManagersPayload({ assignees, removedManagerId }) {
  return {
    [REQUEST_PROFILE_WIDGET_EDIT_MANAGER_FIELD_NAME_ASSIGNEES]: {
      user_ids: getItemsIds(assignees || EMPTY_LIST).filter(
        id => id !== removedManagerId
      ),
    },
  }
}
